import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import ModalUser from "../SetCommander/ModalUser";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../../api/axios";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import MyDatePicker from "../../../components/Common/MyDateTimePicker";
import { ConvertDate } from "../../Function/ConvertDate";
import DatePicker from 'react-datepicker';
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import LoadingPerson from "../../TESTPage/LoadingPerson";

const API_URL = process.env.REACT_APP_API_CORS;

function AddCommander(props) {
  const { onButtonClick } = props;
  const { insert, setInsert } = useInsertConText();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [orgName, setOrgName] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState(0);
  const [isDefault, setIsDefault] = useState(0);
  const [position_Name, setPosition_Name] = useState(null);
  const [position_ID, setPosition_ID] = useState(null);
  const [approveLeave, setApproveLeave] = useState(0);
  const [reportEntryExit, setReportEntryExit] = useState(0);
  const [userDataOrg, setUserDataOrg] = useState([]);
  const [userDataOrgIsDeFault, setUserDataOrgIsDeFault] = useState([]);
  const [masterdata, setMasterdata] = useState([]);
  const [conToPosition, setConToPosition] = useState([]);
  const [typeSubAdminAll, setTypeSubAdminAll] = useState(null);
  const [type1SubAdmin, setType1SubAdmin] = useState(null);
  const [type2SubAdmin, setType2SubAdmin] = useState(null);
  const [type3SubAdmin, setType3SubAdmin] = useState(null);
  const [type4SubAdmin, setType4SubAdmin] = useState(null);
  const [type5SubAdmin, setType5SubAdmin] = useState(null);
  const [type6SubAdmin, setType6SubAdmin] = useState(null);

  const [confirmModal, setConfirmModal] = useState(false)
  const [checkValidateUserName, setCheckValidateUserName] = useState(false)

  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const filterSubAdmin = userData.positionSubAdmin.map(i => i.type_sub_admin);
  // const is_default = JSON.stringify(userData.position?.map(i => i.is_default));
  const positionURL = "/api/users/position/save";

  const checkArledySubAddmin = async () =>{
    const url = "/api/subAdmin/datatable"
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "id",
      "order[1]": "DESC",
      "filter[user_id][0]": userID,
    })
    const res = await FetchAxiosGet(url,token,params)
    if (res.result.length > 0 ) {
      setCheckValidateUserName(true)
    } else {
      setCheckValidateUserName(false)
    }
  }

  const toggleRightCanvasT = () => {
    setLoading(true);
    // setTypeSubAdmin(null);
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setPosition_ID(null);
    setReportEntryExit(null);
    setStatus(null);
    setUserID(null);
    setUserName(null);
    setOrgId(null);
    setOrgName(null);
    setOpen(!open);
    fetchMasterData();
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  const toggleRightCanvasF = () => {
    setLoading(true);
    onButtonClick();
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setPosition_ID(null);
    setReportEntryExit(null);
    setStatus(null);
    setTimeout(() => {
      setLoading(false);
      setOpen(!open);
    }, 2500);
  };

  const toggleRightCanvasFS = () => {
    setLoading(true);
    setCheckValidateUserName(false)
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setPosition_ID(null);
    setReportEntryExit(null);
    setStatus(null);
    setInsert({ insert_name: null, insert_id: null });
    setTimeout(() => {
      setLoading(false);
      setUserID(null);
      setUserName(null);
      setOrgId(null);
      setOrgName(null);
      setOpen(!open);
    }, 300);
  };

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // useEffect(() => {
  //   if (typeSubAdminAll === 0) {
  //   }
  // }, [typeSubAdminAll]);



  const handleSubmit = async () => {
    const data = {
      position_id: position_ID,
      position_name: position_Name,
      user_id: userID,
      is_default: isDefault,
      date_start: startDate,
      date_end: endDate,
      org_id: orgId,
      status: status,
      assign: 0,
      approve_leave: approveLeave,
      report_entry_exit: reportEntryExit,
    };
    let params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "id",
      "order[1]": "ASC",
      "filter[org_id][0]": orgId, 
      "filter[position_id][0]": position_ID, 
      "filter[status][0]": "1", 
    })
    const subAdminURL = "/api/subAdmin/save";
    await FetchAxiosPost(positionURL, data, token).then(async(response)=>{
      const fetchDateCancle = await FetchAxiosGet('/api/users/position/datatable', token, params)
      if (fetchDateCancle.result.length > 1) {
        for (let index = 0; index < fetchDateCancle.result.length; index++) {
          const element = fetchDateCancle.result[index];
          const elementLast = fetchDateCancle.result[fetchDateCancle.result.length - 1];
          if (Number(userID) !== Number(element.user_id)) {
            const originalDate = new Date(elementLast.date_start);
            originalDate.setDate(originalDate.getDate() - 1);
            const urlEdit = `/api/users/position/${element.id}`
            const dataEdit =  {
              position_id: element.position_id,
              position_name: element.position_name,
              user_id: element.user_id,
              is_default: element.is_default,
              date_start: element.date_start,
              date_end: originalDate.toISOString(),
              status: "0",
            }
            const fetchEditCancelDate = await FetchAxiosPut(urlEdit,dataEdit,token)
          }
        }
      }
      if (status === 1) {
        if ( typeSubAdminAll !== null || type1SubAdmin !== null || type2SubAdmin !== null || type3SubAdmin !== null || type4SubAdmin !== null || type5SubAdmin !== null || type6SubAdmin !== null) {
          let subAdmin_data_all = {
            users_position_id: position_ID,
            user_id: userID,
            date_start: startDate,
            date_end: endDate,
            status: status,
            pk_user_position_id: response
          };
          if (typeSubAdminAll === "0") {
            subAdmin_data_all.type_sub_admin = typeSubAdminAll
            FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
          } else {
            if (type1SubAdmin === "1") {
              subAdmin_data_all.type_sub_admin = type1SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
            if (type2SubAdmin === "2") {
              subAdmin_data_all.type_sub_admin = type2SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
            if (type3SubAdmin === "3") {
              subAdmin_data_all.type_sub_admin = type3SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
            if (type4SubAdmin === "4") {
              subAdmin_data_all.type_sub_admin = type4SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
            if (type5SubAdmin === "5") {
              subAdmin_data_all.type_sub_admin = type5SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
            if (type6SubAdmin === "6") {
              subAdmin_data_all.type_sub_admin = type6SubAdmin
              FetchAxiosPost(subAdminURL, subAdmin_data_all, token);
            }
          }
        }
      }
    })

    if (conToPosition.length !== 0) {
      const contoURLDel = `/api/users/${userID}`;
      let arrayPosition = [2,3,4,5,6,7]
      let data_con_to_id_Del = {
        user_title_id: conToPosition.user_title_id,
        user_title_name: conToPosition.user_title_name,
        user_name: conToPosition.user_name,
        user_idcard: conToPosition.user_idcard,
        user_email: conToPosition.user_email,
        user_login: conToPosition.user_login,
        cont_to_id: 0,
      };
      arrayPosition.forEach(element => { data_con_to_id_Del[`cont_to_id${element}`] = 0 });
      await FetchAxiosPut(contoURLDel, data_con_to_id_Del, token);
          userDataOrg.push(orgId);
          const filtereduserDataOrg = userDataOrg.filter(item => !userDataOrgIsDeFault.includes(item));
          let uniqueArray = Array.from(new Set(filtereduserDataOrg)).filter(item => item !== null);
          
          let data_con_to_id_All = {
            user_title_id: conToPosition.user_title_id,
            user_title_name: conToPosition.user_title_name,
            user_name: conToPosition.user_name,
            user_idcard: conToPosition.user_idcard,
            user_email: conToPosition.user_email,
            user_login: conToPosition.user_login,
            // cont_to_id: userDataOrgIsDeFault.length > 0 ? Number(userDataOrgIsDeFault) : orgId,
          };
          // if (uniqueArray.length > 1) {
          //   for (let i = 1; i <= uniqueArray.length; i++) {
          //     const currentNumber = filtereduserDataOrg[i - 1];
          //     data_con_to_id_All[`cont_to_id${i + 1}`] = Number(currentNumber)
          //   }
          // }
          for (let i = 1; i <= uniqueArray.length; i++) {
            const currentNumber = filtereduserDataOrg[i - 1];
            if (i == 1) {
              data_con_to_id_All[`cont_to_id`] = Number(currentNumber)
            } else {
              data_con_to_id_All[`cont_to_id${i}`] = Number(currentNumber)
            }
          }
          // console.log(uniqueArray,conToPosition, data_con_to_id_All, userDataOrgIsDeFault, filtereduserDataOrg)
          await FetchAxiosPut(contoURLDel, data_con_to_id_All, token);
    }

    setTimeout(() => {
      setUserID(null);
      setUserName(null);
      setOrgId(null);
      setOrgName(null);
    }, 500);
  };

  const checkOrgUserPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        const uniqueOrgIds = new Set(
          response.data.result.map(item => item.org_id)
        );
        const uniqueOrgIdsArray = Array.from(uniqueOrgIds);
        setUserDataOrg(uniqueOrgIdsArray);
      })
      .catch(error => console.error("Error:", error));
  };

  const checkOrgUserIsDefaultPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[is_default][0]": "1",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        setUserDataOrgIsDeFault(response.data.result.map(i => i.org_id));
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };


  const OrgFuctionName = id => {
    const url = `${API_URL}/api/users/${id}`;
    const params = new URLSearchParams({});
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setConToPosition(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (insert.task === "สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา") {
      setOrgId(insert.insert_id);
      if (insert.insert_name !== undefined && insert.insert_name !== null) {
        const test = insert.insert_name?.split(",");
        setOrgName(() => test);
      }
    }
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
      OrgFuctionName(insert.insert_id);
      checkOrgUserPosition(insert.insert_id);
      checkOrgUserIsDefaultPosition(insert.insert_id);
    }
  }, [insert, userName]);

  useEffect(() => {
    if (position_ID !== 8) {
      setApproveLeave(0);
    }
  }, [position_ID]);

  useEffect(() => {
    if (userName !== null) {
      checkArledySubAddmin()
    }
  }, [userID])

  return (
    <Fragment>
      <Button onClick={toggleRightCanvasT} color="primary">
        <i className="fa-solid fa-user-plus me-1"></i> เพิ่มใหม่
      </Button>
      <Offcanvas
        style={{ border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvasFS}
        fade
        className="fade custom-w-50"
      >
        <OffcanvasHeader style={{ background: "#2a3042", color: "white" }}>
          <i className="fa-solid fa-plus"></i> รายละเอียดข้อมูลผู้บังคับบัญชา
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggleRightCanvasFS}></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {loading ? (
            <LoadingPerson />
          ) : (
            <FadeIn>
              <ConfirmModal
                 modal = {confirmModal}
                 modalSize = "md"
                 modalHeaderContent = "คุณต้องการที่จะเพิ่มตำแหน่งการปฏิบัติราชการใช่หรือไม่?"
                 onClickConfirmBtn={() => {
                  handleSubmit();
                  toggleRightCanvasF();
                  setConfirmModal(false)
                 }}
                 onClickCancelBtn={() => {
                   setConfirmModal(false)
                 }}
                />
              <Form
                onSubmit={e => {
                  e.preventDefault();
                  setConfirmModal(true)
                }}
              >
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>เจ้าหน้าที่</Label>
                      <InputGroup>
                        <Input
                          readOnly
                          defaultValue={userName}
                          name="user_name"
                          placeholder=""
                          type="text"
                          invalid={!userName}
                        />
                        <ModalUser task="user_ผู้บังคับบัญชา" showSelectedAllMenu={true}/>
                      </InputGroup>
                      {!userName && <FormFeedback>โปรดกรอกข้อมูล</FormFeedback>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>สำนัก/กอง/กลุ่ม</Label>
                      <InputGroup>
                        <Input
                          readOnly
                          defaultValue={orgName ? orgName[0] : ""}
                          name="org_name"
                          placeholder=""
                          type="text"
                          invalid={!orgName}
                        />
                        <ModalConID
                          user_id={userID}
                          task="สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา"
                          taskFilter = "NEED_ADMINISTER"
                        />
                      </InputGroup>
                      {!orgName && <FormFeedback>โปรดกรอกข้อมูล</FormFeedback>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      {masterdata.users_position?.map((masterdata, index) =>
                        masterdata.users_position_id !== 1 ? (
                          // && masterdata.users_position_id !== 8
                          <>
                            <InputGroup className="my-2" key={index}>
                              <InputGroupText>
                                <Input
                                  addon
                                  type="radio"
                                  name="users_position_id"
                                  onChange={e => {
                                    setPosition_ID(
                                      e.target.checked
                                        ? masterdata.users_position_id
                                        : null
                                    );
                                    setPosition_Name(
                                      e.target.checked
                                        ? masterdata.users_position_name
                                        : null
                                    );
                                  }}
                                />
                              </InputGroupText>
                              <Input
                                readOnly
                                defaultValue={masterdata.users_position_name}
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                }}
                              />
                            </InputGroup>
                          </>
                        ) : (
                          ""
                        )
                      )}
                      {position_ID === 8 ? (
                        <Row>
                          <Col lg={6}>
                            <InputGroup className="my-2">
                              <InputGroupText>
                                <Input
                                  addon
                                  type="checkbox"
                                  name="approve_leave"
                                  onChange={e => {
                                    setApproveLeave(e.target.checked ? 1 : 0);
                                  }}
                                />
                              </InputGroupText>
                              <Input
                                readOnly
                                defaultValue={"มีสิทธิ์อนุมัติการลา"}
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col lg={6}>
                            <InputGroup className="my-2">
                              <InputGroupText>
                                <Input
                                  addon
                                  type="checkbox"
                                  name="report_entry_exit"
                                  onChange={e => {
                                    setReportEntryExit(
                                      e.target.checked ? 1 : 0
                                    );
                                  }}
                                />
                              </InputGroupText>
                              <Input
                                readOnly
                                defaultValue={"รายงานการเข้าออก"}
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                }}
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      {(filterSubAdmin.length > 0 && !(Number(filterSubAdmin) === 5)) &&
                        <Fragment>
                          <FormGroup>
                          <Label>ผู้ดูแลระบบย่อย</Label>
                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                disabled={
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                defaultChecked={typeSubAdminAll}
                                onChange={e => {
                                  const isChecked = e.target.checked;
                                  setTypeSubAdminAll(isChecked ? "0" : null);

                                  if (isChecked) {
                                    [
                                      setType1SubAdmin,
                                      setType2SubAdmin,
                                      setType3SubAdmin,
                                      setType4SubAdmin,
                                      setType5SubAdmin,
                                      setType6SubAdmin,
                                    ].forEach(setType => {
                                      setType(null);
                                    });
                                  }
                                }}
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ผู้ดูแลระบบงานทั้งหมด"
                            />
                          </InputGroup>

                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type1SubAdmin}
                                onChange={e =>
                                  setType1SubAdmin(e.target.checked ? "1" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบลาออนไลน์"
                            />
                          </InputGroup>
                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type2SubAdmin}
                                onChange={e =>
                                  setType2SubAdmin(e.target.checked ? "2" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบลงเวลาปฏิบัติงานแบบยืดหยุ่น"
                            />
                          </InputGroup>
                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type3SubAdmin}
                                onChange={e =>
                                  setType3SubAdmin(e.target.checked ? "3" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบการประเมินผล การปฏิบัติราชการแบบออนไลน์"
                            />
                          </InputGroup>
                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type4SubAdmin}
                                onChange={e =>
                                  setType4SubAdmin(e.target.checked ? "4" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบทรัพยากรออนไลน์"
                            />
                          </InputGroup>

                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type5SubAdmin}
                                onChange={e =>
                                  setType5SubAdmin(e.target.checked ? "5" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบจัดการข้อมูล"
                            />
                          </InputGroup>

                          <InputGroup className="mb-1">
                            <InputGroupText>
                              <Input
                                disabled={
                                  typeSubAdminAll === "0" ||
                                  status === 0 ||
                                  checkValidateUserName ||
                                  status === null ||
                                  status === undefined
                                    ? true
                                    : false
                                }
                                name="users_position_sub_admin"
                                type="checkbox"
                                addon
                                defaultChecked={type6SubAdmin}
                                onChange={e =>
                                  setType6SubAdmin(e.target.checked ? "6" : null)
                                }
                              ></Input>
                            </InputGroupText>

                            <Input
                              disabled={
                                typeSubAdminAll === "0" ||
                                status === 0 ||
                                checkValidateUserName ||
                                status === null ||
                                status === undefined
                                  ? true
                                  : false
                              }
                              readOnly
                              placeholder="ระบบจัดการไฟล์เงินเดือน"
                            />
                          </InputGroup>
                          </FormGroup>
                          {/* {status === 0 ||
                            status === null ||
                            status === undefined ? (
                              <div id="liveAlertPlaceholder">
                                <Alert
                                  color="danger"
                                  className="text-danger"
                                  isOpen={
                                    status === 0 ||
                                    status === null ||
                                    status === undefined
                                  }
                                >
                                  ต้องเปิดการใช้งานจึงจะสามารถเลือกผู้ดูแลระบบย่อยได้
                                </Alert>
                              </div>
                            ) : (
                              ""
                            )} */}
                          {checkValidateUserName ? (
                              <div id="liveAlertPlaceholder">
                                <Alert
                                  color="danger"
                                  className="text-danger"
                                  isOpen={checkValidateUserName}
                                >
                                  ผู้ใช้นี้มีการลงทะเบียนเป็นผู้ดูแลระบบแล้ว
                                </Alert>
                              </div>
                            ) : status === 0 ||
                            status === null ||
                            status === undefined ? (
                              <div id="liveAlertPlaceholder">
                                <Alert
                                  color="danger"
                                  className="text-danger"
                                  isOpen={
                                    status === 0 ||
                                    status === null ||
                                    status === undefined
                                  }
                                >
                                  ต้องเปิดการใช้งานจึงจะสามารถเลือกผู้ดูแลระบบย่อยได้
                                </Alert>
                              </div>
                            ) : (
                              ""
                            )}
                        </Fragment>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <FormGroup>
                      <Label>วันที่เริ่ม</Label>
                      {/* <Input
                        name="start_date"
                        type="date"
                        value={new Date(startDate).toISOString()?.split("T")[0]}
                        onChange={e => setStartDate(e.target.value)}
                        invalid={!startDate}
                      /> */}
                      <MyThaiDatePick placeholderText = "เลือกวันที่เริ่มต้น..." setProbsDate = {setStartDate}/>
                      {!startDate && (
                        <FormFeedback>โปรดกรอกข้อมูล</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col lg={6}>
                    <FormGroup>
                      <Label>วันที่สิ้นสุด</Label>
                      {/* <Input
                        name="date_end"
                        type="date"
                        onChange={e => setEndDate(e.target.value)}
                      /> */}
                      <MyThaiDatePick minDate = {startDate} placeholderText = "เลือกวันที่สิ้นสุด..." setProbsDate = {setEndDate}/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <InputGroup className="my-2">
                      <Input
                        readOnly
                        placeholder="Check it out"
                        defaultValue="ใช้งาน"
                        style={{
                          cursor: "pointer",
                          transition: "background-color 0.3s",
                        }}
                      />
                      <InputGroupText>
                        <Input
                          addon
                          type="checkbox"
                          name="user_commander"
                          onChange={e => setStatus(e.target.checked ? 1 : 0)}
                        />
                      </InputGroupText>
                    </InputGroup>
                  </Col>

                  <Col lg={6}>
                    <InputGroup className="my-2">
                      <Input
                        readOnly
                        placeholder="Check it out"
                        defaultValue="ตำแหน่งหลัก"
                        style={{
                          cursor: "pointer",
                          transition: "background-color 0.3s",
                        }}
                      />
                      <InputGroupText>
                        <Input
                          addon
                          type="checkbox"
                          name="is_default"
                          onChange={e => setIsDefault(e.target.checked ? 1 : 0)}
                        />
                      </InputGroupText>
                    </InputGroup>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={4} lg={6} xl={6}></Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={4}
                    lg={3}
                    xl={3}
                    style={{ display: "flex", justifyContent: "end" }}
                    className="mb-2"
                  >
                    <Button
                      disabled={
                        position_ID === null ||
                        position_Name === null ||
                        userID === null ||
                        isDefault === null ||
                        startDate === null ||
                        orgId === null ||
                        status === null
                      }
                      type="submit"
                      color="success"
                      style={{ width: "100%" }}
                    >
                      บันทึก
                    </Button>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={4}
                    lg={3}
                    xl={3}
                    style={{ display: "flex", justifyContent: "end" }}
                    className="mb-2"
                  >
                    <Button
                      color="danger"
                      style={{ width: "100%" }}
                      onClick={toggleRightCanvasFS}
                    >
                      ยกเลิก
                    </Button>
                  </Col>
                </Row>
              </Form>
            </FadeIn>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
}

export default AddCommander;
